<template>
  <div
    style="width: 100%; position: relative"
    :style="
      party?.locationReveled && party?.Address
        ? { padding: 0, background: 'none' }
        : bgStyle
    "
    class="d-flex flex-column align-center justify-end rounded-lg"
  >
    <div
      ref="mapContainer"
      :style="{
        height: party?.locationReveled && !!party?.Address ? '325px' : 'auto',
      }"
      style="width: 100%; border-radius: 12px"
    ></div>
    <template v-if="party?.locationReveled && !!party?.Address">
      <v-card
        style="
          width: calc(100% - 24px);
          position: absolute;
          bottom: 8px;
          left: 12px;
          right: 12px;
          z-index: 3;
        "
        elevation="0"
        class="rounded-lg"
      >
        <v-card-text class="d-flex flex-column">
          <h6 class="mb-0">{{ party?.Address.name }}</h6>
          <p class="text-truncate mb-0">
            {{ fullAddress }}
          </p>
          <v-btn @click="openMaps" small block color="primary" class="mt-1">
            Ver no mapa
          </v-btn>
        </v-card-text>
      </v-card>
    </template>
    <template v-else-if="!!party?.Address">
      <v-card
        style="
          width: calc(100% - 24px);
          position: absolute;
          bottom: 8px;
          left: 12px;
          right: 12px;
          z-index: 3;
        "
        elevation="0"
        class="rounded-lg"
      >
        <v-card-text class="d-flex flex-column">
          <h6 class="mb-0">Endereço não revelado</h6>
          <p class="text-truncate mb-0">
            {{ fullAddress }}
          </p>
        </v-card-text>
      </v-card>
    </template>
    <template v-else>
      <v-card
        style="width: calc(100% - 24px)"
        elevation="0"
        class="rounded-lg ma-4"
      >
        <v-card-text class="d-flex flex-column">
          <v-skeleton-loader
            v-if="loading"
            type="heading"
            class="mb-0"
            height="22"
          />
          <h6 v-else class="mb-0">Endereço não informado</h6>
        </v-card-text>
      </v-card>
    </template>
  </div>
</template>

<script>
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import * as protomapsL from "protomaps-leaflet";
const { VUE_APP_MAPS_KEY, VUE_APP_PROTOMAPS_KEY } = process.env;

export default {
  data() {
    return {
      map: null,
      mapInitialized: false,
    };
  },
  computed: {
    geometry() {
      if (!this.party?.Address?.lat || !this.party?.Address?.lng) return null;
      return {
        lat: this.party.Address.lat,
        lng: this.party.Address.lng,
      };
    },
    fullAddress() {
      if (!this.party?.Address) return "";
      const addrs = this.party.Address;
      var address = "";
      if (this.party.locationReveled) {
        if (addrs.street) {
          address += `${addrs.street}`;
          if (addrs.number) address += `, ${addrs.number}`;
        }
        if (addrs.neighborhood) address += ` - ${addrs.neighborhood}`;
        if (addrs.complement) address += ` - ${addrs.complement}`;
        if (address) address += ` - `;
        address += `${addrs.city} - ${addrs.state}`;
        if (addrs.zipCode) address += ` - ${addrs.zipCode}`;
      } else {
        address = `${addrs.city} - ${addrs.state}`;
      }

      return address;
    },
    bgUrl() {
      if (!!this.party?.Address) {
        const point = this.geometry
          ? `${this.geometry.lat},${this.geometry.lng}`
          : this.fullAddress;

        const url = new URL(`https://maps.googleapis.com/maps/api/staticmap`);
        url.searchParams.set("center", point);
        url.searchParams.set("zoom", this.party?.locationReveled ? "14" : "11");
        url.searchParams.set("size", "900x295");
        url.searchParams.set("key", VUE_APP_MAPS_KEY);
        if (this.party?.locationReveled)
          url.searchParams.set("markers", `color:blue|${point}`);
        if (this.$vuetify.theme.dark)
          url.searchParams.set("map_id", "63f4baff8ff4ba69");

        return `url(${url.toString()})`;
      } else return "url(/img/template-map.jpeg)";
    },
    bgStyle() {
      return {
        backgroundImage: this.bgUrl,
        "min-height": !!this.party?.Address ? "325px" : "auto",
        backgroundPosition: "center top",
        backgroundSize: "cover",
      };
    },
  },
  watch: {
    // Re-initialize map if party changes
    party: {
      handler() {
        this.initMap();
      },
      deep: true,
    },
  },
  mounted() {
    this.initMap();
  },
  watch: {
    geometry() {
      this.initMap();
    },
    party: {
      handler() {
        this.initMap();
      },
      deep: true,
    },
    "$vuetify.theme.dark": {
      handler() {
        this.initMap();
      },
    },
  },
  methods: {
    initMap() {
      const container = this.$refs.mapContainer;
      if (!container) return;
      // Remove existing map if present
      if (this.map) {
        this.map.remove();
        this.map = null;
        this.mapInitialized = false;
      }
      // Only initialize if location is revealed and address is present
      if (!(this.party?.locationReveled && this.party?.Address)) {
        container.style.height = "auto";
        return;
      }
      const coords = this.geometry;
      if (!coords || coords.lat == null || coords.lng == null) return;
      // Initialize Leaflet map

      container.style.height = "325px";
      this.map = L.map(container, {
        center: [coords.lat-0.0015, coords.lng],
        zoom: 14,
        scrollWheelZoom: false,
        doubleClickZoom: false,
        zoomControl: false,
        boxZoom: false,
        touchZoom: false,
        dragging: false,
        attributionControl: false,
        crs: L.CRS.EPSG3857,
      });
      // Add Protomaps tile layer
      const protoLayer = protomapsL.leafletLayer({
        url: `https://api.protomaps.com/tiles/v4/{z}/{x}/{y}.mvt?key=${VUE_APP_PROTOMAPS_KEY}`,
        flavor: this.$vuetify.theme.dark ? "dark" : "light",
        lang: "pt",
      });
      protoLayer.addTo(this.map);
      // Add marker
      L.marker([coords.lat, coords.lng], {
        icon: L.divIcon({
          className: "marker-icon",
          html: `<i aria-hidden="true" class="v-icon notranslate mdi mdi-map-marker theme--light primary--text" style="font-size: 36px;"></i>`,
          iconSize: [36, 36],
          iconAnchor: [18, 32],
        }),
      }).addTo(this.map);
      this.mapInitialized = true;
    },
    openMaps() {
      try {
        let address = this.geometry
          ? `${this.geometry.lat},${this.geometry.lng}`
          : this.fullAddress;
        let url = `https://www.google.com/maps/dir/?api=1&parameters&destination=${address}`;

        this.$posthog.capture("open_maps", {
          partyId: this.party.id,
        });

        window.open(encodeURI(url), "_blank").focus();
      } catch (e) {
        console.log("Erro ao abrir o mapa", e);
      }
    },
  },
  props: {
    party: {
      type: Object,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style>
.marker-icon {
  width: 2px;
  height: 2px;
}
.marker {
  width: 2px;
  height: 2px;
  background-color: var(--v-error-base);
}
</style>
